// src/service/translate/trains/trainTranslations.nl-NL.ts
import type { TrainTranslations } from "./trainTranslations.types";

const trainNlTranslations: TrainTranslations = {
    trainPage: {
        title: "Trein",
        step: "Stap",
        resultsFound: "treinopties gevonden",
        stopOver: "Stop",
        stopOverPlural: "Stops",
        nextStep: "Volgende stap",
        loadingTimeline: "Dienstregeling laden…",
    },
    trainSortBy: {
        title: "Sorteren op",
        price_asc: "Laagste prijs eerst",
        price_desc: "Hoogste prijs eerst",
        fastest: "Snelste",
        fewest_changes: "Minste overstappen"
    },
    trainBlock: {
        title: "Treindienst",
        direct: "Direct",
    },
    trainFilters: {
        outboundTrip: {
            title: "Vertrektijden heenreis",
            duration: "Duur",
            departure: {
                location: "",
                time: "Vertrek"
            },
            arrival: {
                location: "Bestemmingsstation",
                time: "Aankomst"
            }
        },
        inboundTrip: {
            title: "Vertrektijden terugreis",
            duration: "Duur",
            departure: {
                location: "",
                time: "Vertrek"
            },
            arrival: {
                location: "",
                time: "Aankomst"
            }
        },
        operators: "Vervoerder",
        duration: "Reisduur"
    },
    stationsNames: {
        STP: "London St Pancras",
        EBB: "Ebbsfleet International",
        AFI: "Ashford International",
        CMF: "Chambéry-Savoie",
        XAP: "Aime La Plagne",
        XBM: "Bourg St Maurice",
        XBMA: "Bourg St Maurice",
        XAV: "Albertville",
        XMO: "Moutiers",
        XDB: "Lille Europe",
        PLY: "Parijs - Gare de Lyon",
        PAZ: "Parijs Gare d’Austerlitz",
        PEST: "Parijs - Gare de l'Est",
        PARIS: "Parijs - Gare de Lyon",
        AMS: "Amsterdam Centraal",
        RTM: "Rotterdam Centraal",
        ANR: "Antwerpen",
        BRU: "Brussel-Zuid",
        "Bourg-Saint-Maurice": "Bourg Saint Maurice",
        "Aime-la-Plagne": "Aime la Plagne",
        "Moûtiers": "Moûtiers",
    },
    operatorsNames: {
        ES: "Eurostar",
        "9F": "Eurostar",
        PEG: "Pegasus Train",
        PEGASUS: "Pegasus Train"

    },
    trainClass: {
        standard: "Standard",
        premium: "Eerste klas",
        title: "Reistypen",
        outOfStock: "Uitverkocht"
    },
    trainClassCard: {
        yourTrain: "Uw trein",
        travelClass: "Uw reisklasse",
        details: "Details",
        from: "Vanaf",
        included: "Inbegrepen",
        select: "Selecteren",
        classes: {
            seat: {
                title: "Zitplaatsen",
                description: "De perfecte zitplaats voor een voordelige reis.",
            },
            standard: {
                title: "Standaard",
                description: "Standaard couchette met het essentiële voor de reis.",
            },
            standardPlus: {
                title: "Standaard Plus",
                description: "Comfortabele couchette voor een aangename reis.",
            },
            premiere: {
                title: "Eerste klas",
                description: "De premium reisoptie voor reizigers die comfort zoeken.",
            },
        },
        criteria: {
            compartment6: "Compartiment voor 6 personen",
            compartment3: "Compartiment voor 3 personen",
            nonRecliningSeats: "Niet-verstelbare stoelen",
            electricalOutlet: "Stopcontact",
            breakfastOptional: "Ontbijt optioneel",
            sleepingBagSheet: "Slaapzaklaken, kussensloop en dekbed voorzien",
            storageSpace: "Opbergruimte",
            comfortMattress: "Comfortabele matrasbeschermer",
            sheetDuvetPillow: "Laken, dekbed en kussensloop voorzien",
            storageNet: "Opbergnet",
            blackoutBlind: "Verduisteringsgordijn",
            realBeds: "Echte bedden met laken, dekbed en kussensloop.",
            premiumBedding: "Premium beddengoed",
            loungeSeats3: "3 zitplaatsen",
            connectingCompartments: "Verbindingscompartimenten beschikbaar",
            privateSink: "Privé wastafel",
            largeStorage: "Grote opbergruimte",
        },
        subOptions: {
            individualBerths: {
                title: "2 individuele couchettes",
                description: "Beleef een unieke ervaring tijdens de reis in een gedeelde cabine voor 6 personen.",
            },
            privateCompartment: {
                title: "Privé compartiment voor 6 personen",
                description: "Reserveer een volledig compartiment, alleen of met anderen, voor uw reis met familie of vrienden.",
            },
        },
        modal: {
            serviceTitle: "Service",
            services: {
                seat: {
                    breakfastOptional: "Ontbijt optioneel",
                },
                standard: {
                    breakfastOptional: "Ontbijt optioneel",
                },
                standardPlus: {
                    breakfastOptional: "Ontbijt optioneel",
                    comfortKit: "Comfortkits: matrasbeschermer + dekbed (€5,50/pers)",
                },
                premiere: {
                    breakfastOptional: "Ontbijt optioneel",
                },
            },
        },
    }
};

export default trainNlTranslations;
